import React, { Component } from 'react'
import {
  VictoryChart,
  VictoryLine,
  VictoryScatter,
  VictoryTheme,
  VictoryZoomContainer,
  VictoryTooltip
} from 'victory'
// import { format } from 'date-fns/esm'

const INTERPOLATION = 'monotoneX'

class LineChart extends Component {
  constructor (props) {
    super(props)
    const { datetime } = this.props
    this.state = {
      brushDomain: { x: [datetime, datetime + 104000] }
    }
  }

  handleBrush = domain => {
    // this.setState({zoomDomain: domain})
  }

  handleBrushClicked = event => {
    console.log(event.target.nodeName)
    if (event.target.nodeName === 'svg') {
      console.log('stopping propagation')
      event.stopPropagation()
    }
  }

  handleMouseEnter = (event, data) => {
    const { handleMouseEnter } = this.props
    handleMouseEnter(event, data)
  }

  handleMouseLeave = (event, data) => {
    const { handleMouseLeave } = this.props
    handleMouseLeave(event, data)
  }

  handleZoomToObject = (event, data) => {
    const { handleZoomToObject } = this.props
    handleZoomToObject(event, data)
  }

  handleClick (event, props) {
    const { setNewTimeRequested } = this.props
    const activePoint = props.activePoints.find(item => item.timestamp)
    if (activePoint && activePoint.timestamp) {
      const timestamp = new Date(activePoint.timestamp).getTime()
      setNewTimeRequested(timestamp, 'Mopra')
    }
  }

  createGroups = (
    data,
    x,
    y,
    groupByFilters,
    datetime,
    uuidsHighlighted,
    chartStyles,
    chartLabels
  ) => {
    // const timestamp = new Date(datetime).toISOString()

    const groupedData = groupByFilters.map(filter => data.filter(filter))
    const groups = groupedData.map(data => [
      <VictoryLine
        data={data}
        x={x}
        y={y}
        interpolation={INTERPOLATION}
        style={chartStyles ? chartStyles.line : { data: { strokeWidth: 3 } }}
        events={[
          {
            target: 'data',
            eventHandlers: {
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }
          }
        ]}
      />,
      <VictoryScatter
        data={data}
        x={x}
        y={y}
        size={8}
        labels={chartLabels ? chartLabels.scatter : null}
        labelComponent={<VictoryTooltip />}
        style={chartStyles ? chartStyles.scatter : null}
        events={[
          {
            target: 'data',
            eventHandlers: {
              onClick: this.handleZoomToObject,
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }
          }
        ]}
      />
    ])

    return groups
  }

  // createVerticalLine = (verticalLineAccessor, datetime) => {
  //   return <VictoryLine x={() => new Date(datetime).getTime()} />
  // }

  render () {
    const {
      data,
      x,
      y,
      groupByFilters,
      // verticalLineAccessor,
      datetime,
      uuidsHighlighted,
      chartStyles,
      chartLabels
          } = this.props

    const groups = this.createGroups(
      data,
      x,
      y,
      groupByFilters,
      datetime,
      uuidsHighlighted,
      chartStyles,
      chartLabels
    )
    // const verticalLine = this.createVerticalLine(verticalLineAccessor, datetime)

    return (
      <VictoryChart
        scale={{ x: 'time' }}
        theme={VictoryTheme.material}
        padding={{ bottom: 50, top: 10, left: 45, right: 10 }}
        width={600}
        height={300}
        domainPadding={{ x: 10, y: 25 }}
        style={{ parent: { cursor: 'pointer' } }}

      >
        {groups}
      </VictoryChart>
    )
  }
}
export default LineChart



// WEBPACK FOOTER //
// ./src/charts/LineChart.js